import { CreateReturnOfGoodsFromVendorsDto } from "./../../../dtos/documents/ReturnOfGoodsFromVendors/CreateReturnOfGoodsFromVendorsDto";
import { ReturnOfGoodsFromVendorsService } from "./../../../services/documents/ReturnOfGoodsFromVendorsService";
import { ReturnOfGOodsFromVendorsDetail } from "./../../../components/Pages/Documents/ReturnOfGoodsFromVendors/ReturnOfGoodsFromVendorsDetail";
import React from "react";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import ReturnOfGOodsFromVendorsList from "../../../components/Pages/Documents/ReturnOfGoodsFromVendors/ReturnOfGoodsFromVendorsList";

export const ReturnOfGoodsFromVendors: IAppEntity = {
  entityType: "document",
  title: "Return Of Goods From Vendors",
  pluralTitle: "Return Of Goods From Vendors",
  apiUrl: "returnOfGoodsFromVendorGoods",
  apiEnum: ReferenceTypes.DocumentEmployeeDismissal,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ReturnOfGOodsFromVendorsDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ReturnOfGOodsFromVendorsList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getDataService: () =>
    new ReturnOfGoodsFromVendorsService("ReturnOfGoodsFromVendors"),
  getEmptyModel: () => {
    const model: CreateReturnOfGoodsFromVendorsDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      documentDate: new Date(),
      createdDate: new Date(),
      returnOfGoodsFromVendorGoods: [],
    };
    return model;
  },
};
